function comColRemove(){
  $('.form-popup').on('click', '.form-row .remove-row', function() {
    $(this).closest('.cloned-fields').remove();
  })
}

export default comColRemove();



// WEBPACK FOOTER //
// ../markup/assets/js/com-col-remove.js